"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DROP_SHADOWS = void 0;
var DROP_SHADOWS = {
  Z0: 'z0',
  Z1: 'z1',
  Z2: 'z2',
  Z3: 'z3',
  Z4: 'z4',
  Z5: 'z5'
};
exports.DROP_SHADOWS = DROP_SHADOWS;